import { useTranslation } from 'react-i18next';

const styles = {
  wrapper: 'w-full min-w-0 overflow-x-auto',
  container: 'border border-border rounded-lg w-full min-w-[920px]',
  header: {
    container: 'bg-muted border-b border-border flex items-center px-2 w-full',
    column: 'flex-1 min-w-0 px-2 py-3',
    columnRight: 'flex-1 min-w-0 px-2 py-3 text-right',
    label: 'text-sm font-medium text-muted-foreground truncate',
  },
  row: {
    container: 'flex items-center px-2 py-4 border-b border-border last:border-b-0',
    column: 'flex-1 min-w-0 px-2',
    columnRight: 'flex-1 min-w-0 px-2 flex justify-end',
  },
  skeleton: {
    base: 'bg-muted rounded animate-pulse max-w-full',
    checkbox: 'h-4 w-4',
    name: 'h-4 w-48',
    email: 'h-4 w-64',
    role: 'h-4 w-40',
    status: 'h-4 w-24',
    stores: 'h-4 w-24',
    actions: 'h-4 w-12',
  },
};

export const EmployeesTableSkeleton = (): React.ReactElement => {
  const { t } = useTranslation('personnel-employees');

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header.container}>
          <div className={styles.header.column} />
          <div className={styles.header.columnRight}>
            <p className={styles.header.label}>{t('list.table.columns.name')}</p>
          </div>
          <div className={styles.header.columnRight}>
            <p className={styles.header.label}>{t('list.table.columns.email')}</p>
          </div>
          <div className={styles.header.columnRight}>
            <p className={styles.header.label}>{t('list.table.columns.role')}</p>
          </div>
          <div className={styles.header.columnRight}>
            <p className={styles.header.label}>{t('list.table.columns.status')}</p>
          </div>
          <div className={styles.header.columnRight}>
            <p className={styles.header.label}>{t('list.table.columns.stores')}</p>
          </div>
          <div className={styles.header.columnRight} />
        </div>

        <div>
          {Array.from({ length: 10 }).map((_, index) => (
            <div className={styles.row.container} key={index}>
              <div className={styles.row.column}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.checkbox}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.name}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.email}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.role}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.status}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.stores}`} />
              </div>
              <div className={styles.row.columnRight}>
                <div className={`${styles.skeleton.base} ${styles.skeleton.actions}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
